// used as localStorage key for NS_SSO. It is imported
// and checked in multiple packages. Do a search to see where.
const NS_SSO = 'ns_sso';
export default NS_SSO;
